/**
 * Yutulan (kullanıcıya gösterilmeyen) hatalar için merkezi sayaç.
 *
 * Depolama kapalı, kota dolu, medya anahtarı çözülemedi gibi durumlarda
 * uygulama bilinçli olarak devam eder. Bu hataların **tamamen görünmez**
 * olması hata ayıklamayı zorlaştırıyordu (G-35).
 *
 * Sayaç yalnız bellekte tutulur; içerik, dosya yolu veya jeton kaydedilmez.
 * Geliştirme/test dışında gürültü yapmamak için konsola yazılmaz.
 */
export interface SwallowedErrorSnapshot {
  total: number;
  byScope: Record<string, number>;
}

const counts = new Map<string, number>();
let total = 0;

/** Bir yutulan hatayı kapsamıyla kaydeder. */
export function recordSwallowed(scope: string, error: unknown): void {
  total += 1;
  counts.set(scope, (counts.get(scope) ?? 0) + 1);

  // Test ve üretimde sessiz; geliştirmede tek satır ipucu.
  if (import.meta.env.DEV && import.meta.env.MODE !== 'test') {
    const name =
      error instanceof Error ? error.name : typeof error === 'string' ? 'string' : 'unknown';
    console.debug(`[pbfork] yutulan hata (${scope}): ${name}`);
  }
}

/** Tanılama için anlık sayaç görüntüsü. */
export function swallowedErrorSnapshot(): SwallowedErrorSnapshot {
  return { total, byScope: Object.fromEntries(counts) };
}

/** Testlerde durumu sıfırlar. */
export function resetSwallowedErrors(): void {
  counts.clear();
  total = 0;
}
